module.exports = __webpack_public_path__ + "media/images/flags/lk-593078c9718a2a7a20d6e8e2242eb739.svg";